import React from 'react';

import ResetPasswordPanel from './ResetPasswordPanel';

interface Props {
  resetToken: string
}

const ResetPasswordScreen = ({ resetToken }: Props): React.ReactElement => (
  <ResetPasswordPanel resetToken={resetToken} />
);

export default ResetPasswordScreen;
